/**
 * TableSorter.ts
 * npm install list.js
 */

// import List from 'list.js'; - this gets an errro
const List = require('list.js');
import { log } from "../../../dist/a11y-issue-logger__dandi-update--october";

const TableSorter = (() => {
    let options = {
        initElem: document.getElementsByClassName("js-sorter"),
    };

    function init() {
        if (options.initElem.length) {
            initEmailTemplateTableSorter();

            if (EWDS_DEBUG) {
                console.log("[DEBUG] TableSorter : initialized");
            }
        }
    }

    function initEmailTemplateTableSorter() {

        var options = {
            valueNames: ["sortIdent", "sortSubject", "sortDate"],
        };

        var Templates = new List("js-email-tempalte-sorter", options);

        var SortButtons = document.querySelectorAll(".sort-button");

        SortButtons.forEach(function (button) {
            button.addEventListener("click", function (event) {
                event.preventDefault();
            });
        });
    }


    return {
        init: init,
    };
})();

export default TableSorter;
